// src/accounts/AccountShell.js
import React, { useMemo, useState } from "react";

export default function AccountShell({
  user,
  subscriptionText,
  hasElementsAccess,
  onUpgrade,
  onRefresh,
  onLogout,
  pages,
  isAdmin = false,
}) {
  const keys = Object.keys(pages);
  const [activeKey, setActiveKey] = useState(keys[0]);

  // ✅ Label rules
  const planLabel = useMemo(() => {
    const raw = String(subscriptionText || "").trim().toLowerCase();
    if (raw === "monthly" || raw === "yearly") return "MASTER";
    return "FREE";
  }, [subscriptionText]);

  const showUpgrade = useMemo(() => {
    const raw = String(subscriptionText || "").trim().toLowerCase();
    return raw !== "monthly" && raw !== "yearly";
  }, [subscriptionText]);

  // ✅ IMPORTANT FIX:
  // pages[activeKey].component is a function like: () => <AccountSettings ... />
  // If we do <ActiveComponent /> React may remount when Dashboard re-renders,
  // because that function identity changes.
  // So we CALL it to get an element: ActiveRender()
  const ActiveRender = useMemo(() => pages?.[activeKey]?.component, [activeKey, pages]);

  return (
    <div className="accShell">
      {/* LEFT SIDEBAR */}
      <aside className="accSidebar">
        <div className="accSideHeader">
          <div className="accAvatar">
            {(user?.name || user?.email || "U").slice(0, 1).toUpperCase()}
          </div>

          <div className="accUserBlock">
            <div className="accUserName">{user?.name || "My Account"}</div>
            <div className="accUserEmail">{user?.email}</div>
          </div>
        </div>

        <div className="accNav">
          {keys.map((k) => (
            <button
              key={k}
              type="button"
              className={`accNavItem ${k === activeKey ? "is-active" : ""}`}
              onClick={() => setActiveKey(k)}
            >
              {pages[k].label}
            </button>
          ))}
        </div>

        <div className="accSideFooter">
          <button type="button" className="accBtn accBtnPrimary accBtnFull" onClick={onLogout}>
            Logout
          </button>
        </div>
      </aside>

      {/* RIGHT CONTENT */}
      <main className="accMain">
        <div className="accHeader">
          <div className="accHeaderLeft">
            <h1 className="accH1">Welcome, {user?.name || user?.email}</h1>

            {!isAdmin ? (
              <div className="accSubRow">
                Subscription: <b>{planLabel}</b>
              </div>
            ) : null}
          </div>

          {!isAdmin && showUpgrade ? (
            <button type="button" className="accBtn accBtnPrimary" onClick={onUpgrade}>
              Upgrade / Subscribe
            </button>
          ) : null}
        </div>

        {/* ✅ FIXED: render the element returned by your page function */}
        <div className="accContent">{typeof ActiveRender === "function" ? ActiveRender() : null}</div>
      </main>
    </div>
  );
}